import React from 'react';
import Chart from 'react-apexcharts';
export default function DummySmallBarChart() {
  const options = {
    chart: {
      type: 'bar',
      width: 60,
      height: 50,
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '30%'
      }
    },
    colors: ['#e6f1f8'],
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    xaxis: {
      crosshairs: {
        width: 1
      }
    },
    tooltip: {
      theme: 'dark',
      enabled: false,
      fixed: {
        enabled: false
      },
      x: {
        show: false
      },
      y: {},
      marker: {
        show: false
      }
    }
  };
  const series = [{
    data: [4, 5, 9, 10, 9, 12, 4, 9, 4, 5, 3, 10]
  }];
  return /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "bar",
    height: "55"
  });
}